var render = function render(_c,_vm){return _c('div',{staticClass:"links inner-body-block"},[_vm._l((_vm.props.data.items),function(item){return [_c('nuxt-link',{key:item.text,staticClass:"link",attrs:{"to":item.link}},[(item.prepend_icon)?_c('div',{staticClass:"icon",domProps:{"innerHTML":_vm._s(item.prepend_icon)}}):_vm._e(),_vm._v("\n            "+_vm._s(item.text)+"\n        ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }